export const documentTypes = ['QUOTATION', 'PROFORMA_INVOICE', 'PURCHASE_ORDER', 'SALES_CONTRACT', 'SHIPPING_ORDER', 'COMMERCIAL_INVOICE', 'PACKING_LIST', 'CUSTOMS_INVOICE', 'BENEFICIARY_CERTIFICATE', 'BILL_OF_LADING', 'AIR_WAYBILL', 'MANIFEST', 'SHIPPING_ADVICE', 'SHIPPING_INSTRUCTION', 'INSURANCE_POLICY', 'CERTIFICATE_OF_ORIGIN', 'GSP_FORM_A', 'ACFTA_FORM_E', 'INSPECTION_CERTIFICATE', 'HEALTH_CERTIFICATE', 'FUMIGATION_CERTIFICATE'] as const;
export type DocumentType = (typeof documentTypes)[number];

export const originInspectionDocumentTypes = ['CERTIFICATE_OF_ORIGIN', 'GSP_FORM_A', 'ACFTA_FORM_E', 'INSPECTION_CERTIFICATE', 'HEALTH_CERTIFICATE', 'FUMIGATION_CERTIFICATE'] as const;
export type OriginInspectionDocumentType = (typeof originInspectionDocumentTypes)[number];
export function isOriginInspectionDocument(value: unknown): value is OriginInspectionDocumentType {
  return typeof value === 'string' && (originInspectionDocumentTypes as readonly string[]).includes(value);
}
export function originInspectionTemplateVersion(type: OriginInspectionDocumentType): string { return `${documentPrefixes[type].toLowerCase()}-template-v1`; }

export const settlementDocumentTypes = ['COMMERCIAL_INVOICE', 'PACKING_LIST', 'CUSTOMS_INVOICE', 'BENEFICIARY_CERTIFICATE'] as const;
export type SettlementDocumentType = (typeof settlementDocumentTypes)[number];

export const transportDocumentTypes = ['BILL_OF_LADING', 'AIR_WAYBILL', 'MANIFEST', 'SHIPPING_ADVICE', 'SHIPPING_INSTRUCTION'] as const;
export type TransportDocumentType = (typeof transportDocumentTypes)[number];
export function isTransportDocument(value: unknown): value is TransportDocumentType {
  return typeof value === 'string' && (transportDocumentTypes as readonly string[]).includes(value);
}
export function transportTemplateVersion(type: TransportDocumentType): string {
  return `${documentPrefixes[type].toLowerCase()}-template-v1`;
}

export function isDocumentType(value: unknown): value is DocumentType {
  return typeof value === 'string' && (documentTypes as readonly string[]).includes(value);
}

export function isSettlementDocument(value: unknown): value is SettlementDocumentType {
  return typeof value === 'string' && (settlementDocumentTypes as readonly string[]).includes(value);
}

export const documentLabels: Record<DocumentType, string> = {
  FUMIGATION_CERTIFICATE: '熏蒸证',
  HEALTH_CERTIFICATE: '健康证',
  INSPECTION_CERTIFICATE: '检验证书',
  ACFTA_FORM_E: 'Form E 东盟',
  GSP_FORM_A: 'Form A 普惠制',
  CERTIFICATE_OF_ORIGIN: 'CO 原产地证',
  INSURANCE_POLICY: '保险单',
  QUOTATION: 'Quotation', PROFORMA_INVOICE: 'PI 形式发票', PURCHASE_ORDER: 'PO 采购订单',
  SALES_CONTRACT: 'SC 销售合同', SHIPPING_ORDER: 'SO 订舱单', COMMERCIAL_INVOICE: 'CI 商业发票',
  PACKING_LIST: 'PL 装箱单', CUSTOMS_INVOICE: '海关发票', BENEFICIARY_CERTIFICATE: '受益人证明',
  BILL_OF_LADING: 'BL 提单', AIR_WAYBILL: 'AWB 空运单', MANIFEST: '舱单', SHIPPING_ADVICE: '装运通知', SHIPPING_INSTRUCTION: 'SI 补料',
};

export const documentPrefixes: Record<DocumentType, string> = {
  FUMIGATION_CERTIFICATE: 'FC',
  HEALTH_CERTIFICATE: 'HC',
  INSPECTION_CERTIFICATE: 'IC',
  ACFTA_FORM_E: 'FORME',
  GSP_FORM_A: 'FORMA',
  CERTIFICATE_OF_ORIGIN: 'CO',
  INSURANCE_POLICY: 'IP',
  QUOTATION: 'QT', PROFORMA_INVOICE: 'PI', PURCHASE_ORDER: 'PO', SALES_CONTRACT: 'SC', SHIPPING_ORDER: 'SO',
  COMMERCIAL_INVOICE: 'CI', PACKING_LIST: 'PL', CUSTOMS_INVOICE: 'CCI', BENEFICIARY_CERTIFICATE: 'BC',
  BILL_OF_LADING: 'BL', AIR_WAYBILL: 'AWB', MANIFEST: 'MF', SHIPPING_ADVICE: 'SA', SHIPPING_INSTRUCTION: 'SI',
};

export const documentTitles: Record<DocumentType, string> = {
  FUMIGATION_CERTIFICATE: 'FUMIGATION CERTIFICATE / 熏蒸证书',
  HEALTH_CERTIFICATE: 'HEALTH CERTIFICATE / 健康证书',
  INSPECTION_CERTIFICATE: 'INSPECTION CERTIFICATE / 检验证书',
  ACFTA_FORM_E: 'FORM E / 中国—东盟自贸区优惠原产地证',
  GSP_FORM_A: 'GSP FORM A / 普惠制原产地证',
  CERTIFICATE_OF_ORIGIN: 'CERTIFICATE OF ORIGIN / 一般原产地证',
  INSURANCE_POLICY: 'INSURANCE POLICY / 保险单',
  QUOTATION: 'QUOTATION', PROFORMA_INVOICE: 'PROFORMA INVOICE', PURCHASE_ORDER: 'PURCHASE ORDER',
  SALES_CONTRACT: 'SALES CONTRACT / CONFIRMATION', SHIPPING_ORDER: 'SHIPPING ORDER / 订舱确认单',
  COMMERCIAL_INVOICE: 'COMMERCIAL INVOICE / 商业发票', PACKING_LIST: 'PACKING LIST / 装箱单',
  CUSTOMS_INVOICE: 'CUSTOMS INVOICE / 海关发票', BENEFICIARY_CERTIFICATE: "BENEFICIARY'S CERTIFICATE / 受益人证明",
  BILL_OF_LADING: 'BILL OF LADING / 海运提单', AIR_WAYBILL: 'AIR WAYBILL / 空运单', MANIFEST: 'MANIFEST / 舱单',
  SHIPPING_ADVICE: 'SHIPPING ADVICE / 装运通知', SHIPPING_INSTRUCTION: 'SHIPPING INSTRUCTION / 补料',
};

export function settlementTemplateVersion(type: SettlementDocumentType): string {
  return `${documentPrefixes[type].toLowerCase()}-template-v1`;
}
